<template>
  <v-list-item>
    <v-list-item-title>
      <div class="flex-container">
        <div>
          <v-tooltip location="bottom" open-delay="800">
            <template #activator="{ props }">
              <v-btn
                variant="text"
                size="22px"
                icon="mdi-play-circle"
                color="primary"
                :active="true"
                v-bind="props"
                @click="raiseEvent(item.fqName)"
              >
              </v-btn>
            </template>
            <span> click to raise</span>
          </v-tooltip>
          <span @click="raiseEvent(item.fqName)">&nbsp;{{ item.name }}</span>
        </div>
        <input
          v-if="item.type && item.type !== 'boolean'"
          v-model="value"
          class="context-input flex-item-end"
          :disabled="!item.writable"
        />
        <div v-else-if="item.type === 'boolean'" class="checkbox-container flex-item-end">
          <input v-model="value" type="checkbox" :readonly="!item.writable" />
        </div>
        <div v-else class="spacer flex-item-end" />
      </div> </v-list-item-title
  ></v-list-item>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { isNumber, Slot } from "../Editor/services/simulation/simulation-control";

const compProps = defineProps<{ item: Slot }>();

const emit = defineEmits(["eventRaised", "valueChanged"]);

const value = computed({
  get() {
    return compProps.item.value;
  },
  set(newValue) {
    if (isNumber(compProps.item) && Number.isFinite(+newValue)) {
      emit("valueChanged", { fqName: compProps.item.fqName, value: newValue });
    }
  },
});

function raiseEvent(eventFqn: string) {
  if (!value.value) {
    value.value = null;
  }
  emit("eventRaised", { fqName: eventFqn, value: compProps.item.value });
}
</script>
<style scoped>
.spacer {
  width: 50px;
}
</style>
<style>
.v-btn:hover > .v-btn__overlay {
  opacity: calc(0.3 * var(--v-theme-overlay-multiplier));
}
</style>
